import { Controller } from "@hotwired/stimulus"
import { getSiteMap } from "@/api/site_maps"
import { mount, unmount } from "svelte"

export default class extends Controller {
  static values = {
    backPath: String,
    siteMapId: String,
  }

  // Loaded on demand so PixiJS stays out of the main bundle. The guard skips mounting if Turbo
  // disconnected the element mid-import, or if a quick reconnect already mounted it. Clearing the
  // element drops the stale copy of the previous mount that a Turbo cache restore brings back.
  async connect() {
    const { default: SiteMapEditor } = await import("@/components/site_map/SiteMapEditor.svelte")
    if (!this.element.isConnected || this.siteMapEditor) return

    this.element.replaceChildren()
    this.siteMapEditor = mount(SiteMapEditor, {
      props: {
        backPath: this.hasBackPathValue ? this.backPathValue : "",
        getSiteMap,
        isRestricted: false,
        siteMapId: this.siteMapIdValue,
      },
      target: this.element,
    })
  }

  disconnect() {
    if (this.siteMapEditor) unmount(this.siteMapEditor)
    this.siteMapEditor = undefined
  }
}
